import { render, staticRenderFns } from "./WholesaleInquiryOtherDetails.vue?vue&type=template&id=47afad5a&scoped=true&"
import script from "./WholesaleInquiryOtherDetails.vue?vue&type=script&lang=js&"
export * from "./WholesaleInquiryOtherDetails.vue?vue&type=script&lang=js&"
import style0 from "./WholesaleInquiryOtherDetails.vue?vue&type=style&index=0&id=47afad5a&scoped=true&lang=css&"
import style1 from "./WholesaleInquiryOtherDetails.vue?vue&type=style&index=1&id=47afad5a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afad5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VRow})
